import React from "react";
import get from "lodash/get";
import { Table } from "antd";
import { Button, Icon } from "antd";
import { Popconfirm } from "antd";

const { Column } = Table;

const SessionTable = ({
  sessionSet,
  licenseSet,
  scenarioSet,
  loading,
  onDelete,
  onEdit,
}) => {
  const licenseSetIndex = licenseSet.reduce(
    (acc, x) => ({ ...acc, [x.id]: x }),
    {}
  );
  const scenarioSetIndex = scenarioSet.reduce(
    (acc, x) => ({ ...acc, [x.id]: x }),
    {}
  );

  return (
    <Table
      rowKey="id"
      dataSource={sessionSet}
      size="middle"
      pagination={false}
      bordered={false}
      loading={loading}
    >
      <Column
        title="PIN"
        dataIndex="pin"
        sorter={(a, b) => a.pin.localeCompare(b.pin)}
      />
      <Column
        title="License"
        dataIndex="licenseId"
        render={(value) => get(licenseSetIndex, [value, "name"], "")}
        sorter={(a, b) => {
          const aName = get(licenseSetIndex, [a.licenseId, "name"], "");
          const bName = get(licenseSetIndex, [b.licenseId, "name"], "");
          return aName.localeCompare(bName);
        }}
      />
      <Column
        title="Scenario"
        dataIndex="scenarioId"
        render={(value) =>
          get(scenarioSetIndex, [value, "name"], "[unavailable]")
        }
        sorter={(a, b) => {
          const aName = get(scenarioSetIndex, [a.scenarioId, "name"], "");
          const bName = get(scenarioSetIndex, [b.scenarioId, "name"], "");
          return aName.localeCompare(bName);
        }}
      />
      <Column
        title="Is active"
        dataIndex="isActive"
        render={(value) => value && <Icon type="check-circle" />}
        sorter={(a, b) => (a.isActive && !b.isActive ? 1 : -1)}
      />
      <Column
        title="Action"
        key="action"
        render={(row) => (
          <Button.Group size="small">
            <Button onClick={() => onEdit(row)}>
              <Icon type="edit" />
            </Button>
            <Popconfirm
              onConfirm={() => onDelete(row)}
              title="Do you really want to delete this session?"
              okText="Yes"
              cancelText="No"
              placement="left"
            >
              <Button type="danger">
                <Icon type="delete" />
              </Button>
            </Popconfirm>
          </Button.Group>
        )}
      />
    </Table>
  );
};
export default SessionTable;
